import {
  CURRENT_USER_REQUEST_ERROR,
  CURRENT_USER_REQUEST_SUCCESS,
  CURRENT_USER_FETCHING,
  LOCK_ERROR,
  LOCK_SUCCESS,
  IS_LOCKING,
  SEND_OTP_ERROR,
  SEND_OTP_SUCCESS,
  IS_SENDING_OTP,
  LOCK_HISTORY_REQUEST_ERROR,
  LOCK_HISTORY_REQUEST_SUCCESS,
  LOCK_HISTORY_FETCHING,
} from './actions'

const initialState = {
  loading: false,
  login: false,
  user: null,
  user_status: null,
  isLocking: false,
  isFetchingHistory: false,
  isSendingOTP: false,
  lock_history_infos: [],
  otp_life_time: null
}

export default function eventReducer(state = initialState, action) {
  switch (action.type) {
    // USER
    case CURRENT_USER_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        login: true,
        user: action.payload.user,
        user_status: action.payload.user_status,
        otp_life_time: action.payload.otp_life_time,
      }
      break;

    case CURRENT_USER_REQUEST_ERROR:
      return {
        ...state,
        loading: false,
      }
      break;

    case CURRENT_USER_FETCHING:
      return {
        ...state,
        loading: true
      }
      break;

    // LOCK ACCOUNT
    case LOCK_SUCCESS:
      return {
        ...state,
        isLocking: false
      }
      break;

    case LOCK_ERROR:
      return {
        ...state,
        isLocking: false
      }
      break;

    case IS_LOCKING:
      return {
        ...state,
        isLocking: true
      }
      break;

    // SEND OTP
    case SEND_OTP_SUCCESS:
      return {
        ...state,
        isSendingOTP: false
      }
      break;

    case SEND_OTP_ERROR:
      return {
        ...state,
        isSendingOTP: false
      }
      break;

    case IS_SENDING_OTP:
      return {
        ...state,
        isSendingOTP: true
      }
      break;

    // LOCK HISTORY
    case LOCK_HISTORY_REQUEST_SUCCESS:
      return {
        ...state,
        isFetchingHistory: false,
        lock_history_infos: action.payload.lock_history_infos,
      }
      break;

    case LOCK_HISTORY_REQUEST_ERROR:
      return {
        ...state,
        isFetchingHistory: false
      }
      break;

    case LOCK_HISTORY_FETCHING:
      return {
        ...state,
        isFetchingHistory: true
      }
      break;

    // DEFAULT
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/routes/Home/modules/reducer.js